import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, IconButton, Tooltip, DialogTitle, useMediaQuery } from '@mui/material';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useSelector } from 'react-redux';
import Loading from './Loading';
import { useTheme } from '@mui/material/styles';
import useFullscreen from '../lessons/details/fullscreen/useFullscreen';
import { useTranslation } from 'react-i18next';
    
export default function AnalyticsDialog() {
    const { t } = useTranslation()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const [open, setOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    let email = localStorage.getItem("userEmail")
    const completedSkills = useSelector((state) => state.user.completedSkills)
    const user = useSelector((state) => state.user.userData?.user)
    let analyticsURL = useSelector((state) => state.user.userData?.analyticsURL) || "https://analytics.stickball.biz/northwell/email/"

    // Fullscreen hook
    const {
        isFullscreen,
        isFullscreenSupported,
        toggleFullscreen,
        elementRef
    } = useFullscreen();

    if (!completedSkills?.length) {
        return <></>
    }

    return (
        <>
            {
                !isMobile ?
                    <Tooltip title="Analytics" arrow>
                        <IconButton
                            color="primary"
                            sx={{
                                position: "fixed",
                                bottom: 340,
                                right: 30,
                                width: "50px",
                                height: "50px",
                                boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.3)",
                                backgroundColor: "#fff",
                            }}
                            onClick={() => setOpen(true)}>
                            <AnalyticsIcon />
                        </IconButton>
                    </Tooltip>
                    :
                    <IconButton
                        variant="rounded"
                        onClick={() => setOpen(true)}>
                        <AnalyticsIcon />
                    </IconButton>
            }

            <Dialog

                fullWidth
                maxWidth="md"
                open={open}
                onClose={() => setOpen(false)}
                PaperProps={{
                    sx: {
                        borderRadius: { md: "32px", xs: "16px" },
                        p: { xs: 0, md: 2 },
                        m: { xs: 0.7, md: 2 },
                        width: { xs: "100%", md: "90%" }
                    }
                }}
            >
                <DialogTitle sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", p: 0 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, }}>
                        {isFullscreenSupported && (
                            <Tooltip title={isFullscreen ? t("Exit fullscreen") : t("Enter fullscreen")} arrow>
                                <IconButton onClick={toggleFullscreen}>
                                    {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                                </IconButton>
                            </Tooltip>
                        )}
                        <Tooltip title={t("Close")} arrow>
                            <IconButton onClick={() => setOpen(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ p: { xs: 0, md: 2 } }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "30px",
                    }}>
                        {
                            isLoading &&
                            <Loading />
                        }
                        <Box
                            ref={elementRef}
                            width="100%"
                            height={isFullscreen ? "100vh" : "fit-content"}
                            sx={{
                                overflow: "auto",
                                px: 1,
                                position: "relative",
                                backgroundColor: isFullscreen ? "#000" : "transparent",
                                ...(isFullscreen && {
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100vw",
                                    height: "100vh",
                                    zIndex: 9999,
                                    mt: 0
                                }),
                            }}
                        >
                            <iframe
                                onLoad={() => setIsLoading(false)}
                                style={{
                                    width: "100%",
                                    maxHeight: isFullscreen ? "100vh" : "70vh",
                                    height: isFullscreen ? "100vh" : "70vh"
                                }}
                                src={`${analyticsURL}/email/${email}/${user?.organizationId}?lang=${localStorage.getItem("lang")}`}
                                frameBorder="0"
                            />
                        </Box>
                    </Box>

                </DialogContent>
            </Dialog>
        </>
    );
}